import { AlpineComponent } from '@alpinejs/csp';

const Tooltip = (): AlpineComponent => ({
  filterOpen: false,

  toggleFilter() {
    this.filterOpen = !this.filterOpen;
  },

  isOpen() {
    return this.filterOpen;
  },
  isNotOpen() {
    return !this.filterOpen;
  },

  getToggleClass() {
    return { 'teaser-grid__filter-toggle--is-open': this.filterOpen };
  }
});

export default Tooltip;
